import de from './locales/de/translation.json';
import en from './locales/en/translation.json';
import es from './locales/es/translation.json';
import fr from './locales/fr/translation.json';
import it from './locales/it/translation.json';
import joiDe from './locales/de/joi-loyalty.json';
import joiEl from './locales/el/joi-loyalty.json';
import joiEn from './locales/en/joi-loyalty.json';
import joiEs from './locales/es/joi-loyalty.json';
import joiFr from './locales/fr/joi-loyalty.json';
import joiIt from './locales/it/joi-loyalty.json';
import joiNl from './locales/nl/joi-loyalty.json';
import joiPt from './locales/pt/joi-loyalty.json';
import nl from './locales/nl/translation.json';
import participantDe from './locales/de/participant.json';
import participantEl from './locales/el/participant.json';
import participantEn from './locales/en/participant.json';
import participantEs from './locales/es/participant.json';
import participantFr from './locales/fr/participant.json';
import participantIt from './locales/it/participant.json';
import participantNl from './locales/nl/participant.json';
import participantPt from './locales/pt/participant.json';
import pt from './locales/pt/translation.json';

export * from './constants';

export const translations = { en, fr, es, nl, pt, de, it };

export const joiTranslations = {
  de: joiDe,
  en: joiEn,
  el: joiEl,
  es: joiEs,
  fr: joiFr,
  nl: joiNl,
  pt: joiPt,
  it: joiIt,
};

export const participantTranslations = {
  de: participantDe,
  el: participantEl,
  en: participantEn,
  es: participantEs,
  fr: participantFr,
  nl: participantNl,
  pt: participantPt,
  it: participantIt,
};
